export default {
  methods: {
    $debug: function $debug(error) {
      if (error.response && error.response.status === 401) {
        this.$router.push({
          name: 'error401'
        }).catch(function () {});
        return false;
      } else if (error.response && error.response.status === 404) {
        this.$router.push({
          name: 'error404'
        }).catch(function () {});
      } else if (error.response && error.response.status === 422) {
        this.$root.$emit('showValidationsModal', error.response.data.errors);
      } else {
        if (error.response && error.response.data && error.response.data.message) {
          this.$q.dialog({
            title: 'An error has occurred',
            message: error.response.data.message
          });
        }
        console.log(error);
      }
      return true;
    }
  }
};